export const formatDocumentName = name => name.split("/").pop().replace(/\.[^/.]+$/, "")